import {
  Box,
  Button,
  CircularProgress,
  Grid,
  StyledEngineProvider,
  ThemeProvider,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { BaseTheme } from '../../../BeaconTheme';
import { IQuickNotation } from '../../../pages/Settings/NotationWidget/Interfaces/IQuickNotation';
import { NotationWidgetService } from '../../../pages/Settings/NotationWidget/Services/NotationWidgetService';
import ErrorBox from '../../ErrorBox';

export interface INotationWidgetWelcome {
  isPreview?: boolean;
  title?: string;
  description?: string;
  width?: number;
}

const NotationWidgetWelcome = (props: INotationWidgetWelcome) => {
  const [quickNotation, setQuickNotation] = useState<IQuickNotation>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isErrored, setIsErrored] = useState<boolean>(false);
  const [calculatedHeaderSize, setCalculatedHeaderSize] = useState<number>(0);

  //TODO: We can move network calls out of here and into the wrapper to treat these as components
  useEffect(() => {
    if (props.isPreview) {
      setIsLoading(false);
      return;
    }
    NotationWidgetService.GetQuickNotationWidgetAllowAnonymous()
      .then(x => {
        if (x) setQuickNotation(x);
        else setIsErrored(true);
      })
      .catch(e => {
        setIsErrored(true);
      })
      .finally(() => {
        if (quickNotation) props.width = quickNotation.width;
        setTimeout(() => setIsLoading(false), 500);
      });
  }, []);

  useEffect(() => {
    //Set the Header font size = 10 vw between 10 and 50px
    let calculatedSize =
      ((props.width ?? quickNotation?.width ?? 0) / 100) * 10;
    setCalculatedHeaderSize(
      calculatedSize <= 50 ? (calculatedSize >= 20 ? calculatedSize : 20) : 35,
    );
  }, [quickNotation, props.width]);

  let description = (
    <>
      <Grid item>
        <Typography>
          Our campus relies on you to ensure that all of our students receive
          the attention they require to maintain their success.
        </Typography>
      </Grid>
      <Grid item>
        <Typography>
          Create an <strong>Alert</strong> to send a high priority notice to
          faculty/staff who work with the student or an <strong>Update</strong>{' '}
          to log a note about the student. Reinforce positive learning
          strategies by giving students <strong>Encouragement</strong>.
        </Typography>
      </Grid>
      <Grid item>
        <Typography>
          Notifications will be sent out to your colleagues with the contents of
          your alert or update.
        </Typography>
      </Grid>
    </>
  );
  if (props.description) {
    description = (
      <Grid item>
        <Typography component="div">
          <div dangerouslySetInnerHTML={{ __html: props.description }} />
        </Typography>
      </Grid>
    );
  } else if (quickNotation?.description) {
    description = (
      <Grid item>
        <Typography component="div">
          <div
            dangerouslySetInnerHTML={{ __html: quickNotation.description }}
          />
        </Typography>
      </Grid>
    );
  }
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={BaseTheme}>
        <Box
          maxWidth={600}
          overflow="auto"
          style={{
            backgroundColor: 'white',
            padding: '10px',
            margin: '1em auto',
          }}
        >
          {isErrored && (
            <ErrorBox
              minHeight={200}
              alignContent="center"
              alignItems="center"
              justifyContent="center"
              display="flex"
            />
          )}
          {!isErrored && isLoading && (
            <Box
              height={200}
              alignContent="center"
              alignItems="center"
              justifyContent="center"
              display="flex"
            >
              <CircularProgress />
            </Box>
          )}
          {!isErrored && !isLoading && (
            <>
              <Grid container direction="column" spacing={2}>
                <Grid item>
                  <Typography
                    variant="h4"
                    align="center"
                    style={{ fontSize: calculatedHeaderSize }}
                  >
                    {props.title ??
                      quickNotation?.titleText ??
                      'Success Network Message'}
                  </Typography>
                </Grid>
                {description}
                <Grid
                  item
                  container
                  justifyContent="center"
                  alignContent="center"
                >
                  <Button
                    onClick={() => {
                      if (props.isPreview) return;
                      window.open(
                        `${
                          //@ts-ignore
                          window.initialAppState.pathContext
                        }/widget/Notation/Select`,
                        'QuickNotation',
                        'width=600,height=800',
                      );
                    }}
                    color="primary"
                    variant="contained"
                  >
                    Create Notation
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default NotationWidgetWelcome;
